// extracted by mini-css-extract-plugin
export default {"heavenOnEarth":"HeavenOnEarth_heavenOnEarth__s5Oqk","heavenOnEarthLabel":"HeavenOnEarth_heavenOnEarthLabel__IwodG"};